import { database } from '@/plugins/firebase'

export const getUserDataById = id => database.ref('users').child(id)

export const geProfileDataByemail = email =>
  database
    .ref('users')
    .orderByChild('email')
    .equalTo(email)
